// third-party

// assets
import {
	AuditOutlined,
	SolutionOutlined,
	ReadOutlined,
	GroupOutlined,
	FundProjectionScreenOutlined,
	ReconciliationOutlined
} from '@ant-design/icons';
import useAuthContext from 'context/useAuthContext';

// type
import { NavItemType } from 'layout/mantis/types/MenuType';

// icons
const icons = {
	reconciliationOutlined: ReconciliationOutlined,
	solutionOutlined: SolutionOutlined,
	readOutlined: ReadOutlined,
	fundProjectionScreenOutlined: FundProjectionScreenOutlined,
	groupOutlined: GroupOutlined,
	auditOutlined: AuditOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export default function ReportsMenuItems() {
	const { permissions, roles } = useAuthContext();
	let items: NavItemType = {};

	if (permissions) {
		if (
			permissions.some((el: string) => {
				return (
					el === 'Admin_Reports' ||
					el === 'Search_Reports' ||
					el === 'Manage_Generated_Reports' ||
					el === 'Manage_Scheduled_Reports'
				);
			})
		) {
			items = {
				id: 'group-reports',
				title: 'Reports',
				type: 'group',
				icon: icons.reconciliationOutlined,
				children: []
			};

			// User Reports
			if (
				permissions.some((el: string) => {
					return el === 'Admin_Reports' || el === 'Search_Reports';
				})
			) {
				let user_report = {
					id: 'core-reports-learner-stats',
					title: 'Learner Stats',
					type: 'collapse',
					icon: icons.solutionOutlined,
					breadcrumbs: true,
					children: []
				};

				if (
					permissions.some((el: string) => {
						return el === 'Admin_Reports';
					})
				) {
					user_report.children.push({
						id: 'core-reports-learner-stats-overall',
						title: 'Overall',
						type: 'item',
						url: '/app/stats/learner/overall',
						breadcrumbs: true
					});
				}

				user_report.children.push({
					id: 'core-reports-learner-stats-individual',
					title: 'Individual',
					type: 'item',
					url: '/app/stats/learner/individual',
					breadcrumbs: true
				});

				items.children.push(user_report);
			}

			if (
				permissions.some((el: string) => {
					return el === 'Admin_Reports';
				})
			) {
				items.children.push({
					id: 'core-reports-lms-reports',
					title: 'LMS Reports',
					type: 'item',
					url: '/app/reports/lms',
					icon: icons.reconciliationOutlined,
					breadcrumbs: true
				});

				// CPD Reports
				items.children.push({
					id: 'core-reports-cpd-record',
					title: 'CPD Report',
					type: 'item',
					url: '/app/stats/cpd/record',
					icon: icons.readOutlined,
					breadcrumbs: true
				});

				// Certificate Reports
				items.children.push({
					id: 'core-reports-course-progress',
					title: 'Course Progress',
					type: 'item',
					url: '/app/reports/course/progress',
					icon: icons.readOutlined,
					breadcrumbs: true
				});

				items.children.push({
					id: 'core-reports-certificate-report',
					title: 'Certificate Report',
					type: 'item',
					url: '/app/reports/certificate/report',
					icon: icons.solutionOutlined,
					breadcrumbs: true
				});

				// feedback Reports
				items.children.push({
					id: 'core-reports-feedback-report',
					title: 'Feedback Report',
					type: 'item',
					url: '/app/reports/feedback/report',
					icon: icons.solutionOutlined,
					breadcrumbs: true
				});
				items.children.push({
					id: 'core-reports-feedback-collection',
					title: 'Feedback Collection',
					type: 'item',
					url: '/app/reports/feedback/collection',
					icon: icons.solutionOutlined,
					breadcrumbs: true
				});
				items.children.push({
					id: 'core-reports-feedback-review-system',
					title: 'Feedback Review System Report',
					type: 'item',
					url: '/app/reports/feedback/review-system',
					icon: icons.solutionOutlined,
					breadcrumbs: true
				});

				// Trainer Reports
				items.children.push({
					id: 'core-reports-trainer-report',
					title: 'Trainer Reports',
					type: 'item',
					url: '/app/reports/trainer',
					icon: icons.readOutlined,
					breadcrumbs: true
				});

				// Attendance Reports
				items.children.push({
					id: 'core-reports-attendance-report',
					title: 'Attendance Reports',
					type: 'item',
					url: '/app/reports/attendance',
					icon: icons.readOutlined,
					breadcrumbs: false
				});
				// Company Summary Reports
				items.children.push({
					id: 'core-reports-company-summary-report',
					title: 'Company Summary Report',
					type: 'item',
					url: '/app/reports/company/summary',
					icon: icons.readOutlined,
					breadcrumbs: true
				});
				// Support Reports
				items.children.push({
					id: 'core-reports-support-report',
					title: 'Support Reports',
					type: 'item',
					url: '/app/reports/support',
					icon: icons.readOutlined,
					breadcrumbs: false
				});

				// Exam Reports
				items.children.push({
					id: 'core-reports-exam-report',
					title: 'Exam Reports',
					type: 'item',
					url: '/app/reports/exam',
					icon: icons.readOutlined,
					breadcrumbs: true
				});

				// Batch Assessment Stats Report
				items.children.push({
					id: 'core-reports-batch-assessment-report',
					title: 'Batch Assessment Report',
					type: 'item',
					url: '/app/reports/batch-assessment',
					icon: icons.solutionOutlined,
					breadcrumbs: true
				});
			}
			if (
				permissions.some((el: string) => {
					return el === 'Manage_Generated_Reports';
				})
			) {
				items.children.push({
					id: 'core-reports-generated',
					title: 'Generated Reports',
					type: 'item',
					url: '/app/reports/generated',
					icon: icons.readOutlined,
					breadcrumbs: true
				});
			}
			if (
				permissions.some((el: string) => {
					return el === 'Manage_Scheduled_Reports';
				})
			) {
				items.children.push({
					id: 'core-reports-scheduled',
					title: 'Scheduled Reports',
					type: 'item',
					url: '/app/reports/scheduled',
					icon: icons.readOutlined,
					breadcrumbs: true
				});
			}

			/*// Batch Reports
			// if (
			// 	permissions.some((el: string) => {
			// 		return el === 'Manage_Batches';
			// 	})
			// ) {
			// 	items.children.push({
			// 		id: 'core-reports-batch-report',
			// 		title: 'Batch Reports',
			// 		type: 'item',
			// 		url: '/app/reports/batch',
			// 		icon: icons.readOutlined,
			// 		breadcrumbs: true
			// 	});
			// }
			// Learner Reports
			// if (
			// 	permissions.some((el: string) => {
			// 		return el === 'Manage_Batches';
			// 	})
			// ) {
			// 	items.children.push({
			// 		id: 'core-reports-learner-report',
			// 		title: 'Learner Reports',
			// 		type: 'item',
			// 		url: '/app/reports/learner',
			// 		icon: icons.readOutlined,
			// 		breadcrumbs: true
			// 	});
			// }

			// Batch Stats
			// if (permissions.some((el: string) => {
			//     return (el === 'Manage_Batches')
			// })) {
			//     let batch_stats = {
			//         id: 'core-reports-batch-stats',
			//         title: 'Batch Stats',
			//         type: 'collapse',
			//         icon: icons.fundProjectionScreenOutlined,
			//         breadcrumbs: true,
			//         children: []

			//     };
			//     batch_stats.children.push({
			//         id: 'core-reports-batch-stats-all',
			//         title: 'All',
			//         type: 'item',
			//         url: '/app/reports/batch/stats/all',
			//         breadcrumbs: true
			//     });

			//     items.children.push(batch_stats);
			// }
			// Group Reports
			// if (permissions.some((el: string) => {
			//     return (el === 'Manage_Batches')
			// })) {
			//     let group_report = {
			//         id: 'core-reports-group-report',
			//         title: 'Group Reports',
			//         type: 'collapse',
			//         icon: icons.groupOutlined,
			//         breadcrumbs: true,
			//         children: []

			//     };
			//     group_report.children.push({
			//         id: 'core-reports-group-report-all',
			//         title: 'All',
			//         type: 'item',
			//         url: '/app/reports/group/all',
			//         breadcrumbs: true
			//     });

			//     items.children.push(group_report);
			// }
			// Exam Reports
			// if (permissions.some((el: string) => {
			//     return (el === 'Manage_Batches')
			// })) {
			//     let exam_report = {
			//         id: 'core-reports-exam-report',
			//         title: 'Exam Reports',
			//         type: 'collapse',
			//         icon: icons.auditOutlined,
			//         breadcrumbs: true,
			//         children: []

			//     };
			//     exam_report.children.push({
			//         id: 'core-reports-exam-report-all',
			//         title: 'All',
			//         type: 'item',
			//         url: '/app/reports/exam/all',
			//         breadcrumbs: true
			//     });

			//     items.children.push(exam_report);
			// }*/
		}
	}

	return items;
}
